<template>
  <!--  <router-link-->
  <!--    :to="`/booking/sign/${applicationUuid}`"-->
  <!--    v-show="isAllowed"-->
  <!--    class="btn btn-primary btn-block mb-1"-->
  <!--    >{{ buttonName }}-->
  <!--  </router-link>-->
  <span v-show="isAllowed" @click="openModal">
    <button class="btn btn-primary">
      {{ buttonName }}
    </button>
  </span>
</template>

<script>
import ButtonMixin from '../mixins/buttonMixin';

export default {
  name: 'booking-sign-btn',
  props: {
    allowedActions: {
      required: true,
      validator: value => {
        if (value !== null) {
          return value.constructor.name == 'Array';
        } else {
          return true;
        }
      },
    },
    type: {
      validator: value => {
        return typeof value === 'string' || value === null;
      },
      required: true,
    },
    applicationUuid: {
      validator: value => {
        return typeof value === 'string' || value === null;
      },
      required: true,
    },
    orderNumber: {
      validator: value => {
        return typeof value === 'string' || value === null;
      },
      required: false,
    },
    bookingInfo: {
      required: true,
    },
  },
  mixins: [ButtonMixin],
  data() {
    return {
      actionName: 'SIGN',
      actionType: 'RENT_TRANSACTION',
    };
  },
  methods: {
    async openModal() {
      this.$modal.show('sign-agreement-modal', {
        uuid: this.bookingInfo.rent_transaction_uuid,
        buttonName: this.buttonName,
        allowedActions: this.allowedActions,
      });
    },
  },
};
</script>

<style scoped></style>
